import { JsonObject } from '../../helpers';
import { ConnectorFeatureSet } from './';
import { ConnectorModel } from './connector.model';
import CloudflareIcon from '@/assets/connector-icons/cloudflare.svg';

export type CloudflareAIConfig = {
  apiKey: string;
  apiKeyLast4?: string;
  accountId: string;
};

export class CloudflareAIConnectorModel extends ConnectorModel {
  config: CloudflareAIConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'cloudflare-ai';
    this.typeLabel = 'Cloudflare AI';
    this.iconSVG = CloudflareIcon;
    this.demo = true;

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: true,
      contextData: false,
      ingress: false,
    };

    this.config = (data.config as CloudflareAIConfig) || {
      apiKey: '',
      accountId: '',
    };

    this.configSecrets = ['apiKey'];
    this.canListProviderModels = true;
  }
}
